var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClapSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 210,
    height: 480,
    opacity: 0.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    width: 210,
    height: 480,
    opacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClapSquare);
export default __webpack_public_path__ + "static/media/ClapSquare.d711204736703cc0042797b4e2894a90.svg";
export { ForwardRef as ReactComponent };